import { styled,T } from '@veracity/vui'

export const BreadCrumbText = styled(T)`
  overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`
